import {applyMiddleware, configureStore, createStore, isRejectedWithValue} from "@reduxjs/toolkit"
import api from "../api/base-api"
import root from "../reducers/index"
import * as Sentry from "@sentry/react";
import {parseFormDataTextToJsonString} from "./utils";
import {CONFIGS} from "../../constants";
import { enableMapSet } from 'immer';

enableMapSet();

Sentry.init({
    dsn: 'https://4261a175d3afd87be92ef16a45884902@ita-sentry.belka-games.com/46',
    environment: CONFIGS.environment
});


const myLoggingMiddleware = storeAPI => next => action => {
    if (isRejectedWithValue(action)) {
        const jsonError = JSON.stringify(action.payload.data);
        action.meta.baseQueryMeta.request.body?.getReader()?.read().then(response =>{
            const jsonRequest = JSON.stringify({body:parseFormDataTextToJsonString(new TextDecoder().decode(response.value))});
            Sentry.captureMessage(
                `Error while sending request\n${jsonError}\n${jsonRequest}`,
                Sentry.Severity.Error
            )
        });
    }
    return next(action)
}

export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        data: root
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware).concat(myLoggingMiddleware)
})
